import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ahoy-paginator',
  templateUrl: './ahoy-paginator.component.html',
  styleUrls: ['./ahoy-paginator.component.scss'],
  standalone: false,
})
export class AhoyPaginatorComponent {
  htmlDirection = localStorage.getItem('html-dir') || 'ltr';

  @Input() paginator!: {
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
  };
  @Output() pageChange = new EventEmitter<number>();

  update(
    res: { pageNumber: number; totalCount: number; pageSize?: number } = {
      pageNumber: 1,
      totalCount: 0,
      pageSize: 10,
    },
  ) {
    return {
      pageNumber: res.pageNumber,
      pageSize: res.pageSize,
      totalCount: res.totalCount,
      totalPages:
        res.totalCount % res.pageSize === 0
          ? res.totalCount / res.pageSize
          : Math.floor(res.totalCount / res.pageSize) + 1,
    };
  }

  updatePage(page: number) {
    if (page < 1 || page > this.paginator.totalPages) {
      return;
    }
    this.paginator.pageNumber = page;
    this.pageChange.emit(this.paginator.pageNumber);
  }
}
